// extracted by mini-css-extract-plugin
module.exports = {"accordion":"Accordion_accordion__32W1L","accordion__link":"Accordion_accordion__link__ymfrz"};